/**
 * Interface to dealing with an &lt;evSecurityImage&gt;.
 * @constructor
 * @extends {Foundation.View}
 * @param {Element} element
 */
Foundation.Form.Captcha = function (element) {
    Foundation.View.call(this, element);
    
    this.element.find('a[href$="#reload"]').click(this.refresh.bind(this));
    this.captchaInput = this.element.find("input[name=captcha]");
    this.captchaId = this.element.find("input[name=captchaId]");
    this.captchaVerification = this.element.find("input[name=captchaVerification]");
    this.img = this.element.find("img");
    this.refresh();
};
Foundation.inherit(Foundation.Form.Captcha, Foundation.View);

/**
 * @param {jQuery.Event=} e
 */
Foundation.Form.Captcha.prototype.refresh = function (e) {
    if (e) e.preventDefault();
    
    if (this.spinner) this.spinner.hide();
    this.spinner = new Foundation.View.Spinner(this.img[0], {
        "width": 65,
        "height": 65,
        "delay": 0.5
    });
    
    this.captchaInput.val("").prop("disabled", true);
    this.img.attr("src", "/foundation/images/spacer.gif");
    
    var response = new Foundation.API("POST", "Captcha", {"delete": this.captchaId.val()});
    response.then((function () {
        this.spinner.hide();
        this.img.attr("src", response.get("url"));
        this.captchaId.val(response.get("id"));
        this.captchaVerification.val(response.get("verification"));
        this.captchaInput.prop("disabled", false);
        this.setAutoRefresh(response.get("expires"));
    }).bind(this));
};

/**
 * Set up the automatic refresh of the captcha to help prevent it from going
 * stale.
 * @param {number} expires Seconds before expiry.
 */
Foundation.Form.Captcha.prototype.setAutoRefresh = function (expires) {
    // Refresh 30 seconds before expiry.
    var milliseconds = (expires - 30) * 1000;
    
    this.clearAutoRefresh();
    this.autoRefreshTimeout = setTimeout(this.autoRefresh.bind(this), milliseconds);
};

Foundation.Form.Captcha.prototype.clearAutoRefresh = function () {
    if (this.autoRefreshTimeout) clearTimeout(this.autoRefreshTimeout);
};

Foundation.Form.Captcha.prototype.autoRefresh = function () {
    // Don't refresh if the captcha input has focus, since that would be
    // rude to the user.
    if (this.captchaInput.is(":focus")) return;
    
    // Don't refresh if the captcha input has a value, since this also
    // would be rude to the user.
    if (this.captchaInput.val() !== "") return;
    
    // Ok, it's safe to refresh.
    this.refresh();
};

/**
 * Verify the captcha answer with the server.
 * @return {Foundation.Promise}
 */
Foundation.Form.Captcha.prototype.verify = function () {
    return new Foundation.API("POST", "Captcha", {
        "verify": "true",
        "captcha": this.captchaInput.val(),
        "captchaVerification": this.captchaVerification.val()
    });
};

/**
 * Destructor.
 */
Foundation.Form.Captcha.prototype.destroy = function () {
    if (this.spinner) this.spinner.hide();
    this.clearAutoRefresh();
};

// ---------------------------------------------------------------------

window["Foundation"]["Form"]["Captcha"] = Foundation.Form.Captcha;
